import { secureRoute } from '@uag/react-core';
import { Route, Routes } from 'react-router-dom';

import { Home } from 'app/Home';
import { WallFormingRoutes, WallFormingBaseRoute } from 'app/modules/Routes';
import { CataloguePage } from 'app/modules/wallforming/CataloguePage';
import { FrustumViewerPage } from 'app/modules/wallforming/components/frustum-viewer/FrustumViewerPage';
import { NotFound } from 'app/NotFound';
import { Unauthorized } from 'app/Unauthorized';

const isE2EAuthBypassEnabled = import.meta.env.VITE_E2E_AUTH_BYPASS === 'true';

const WallFormingRoutesComponent = isE2EAuthBypassEnabled ? WallFormingRoutes : secureRoute(WallFormingRoutes);
const HomeComponent = isE2EAuthBypassEnabled ? Home : secureRoute(Home);
const CataloguePageComponent = isE2EAuthBypassEnabled ? CataloguePage : secureRoute(CataloguePage);
const FrustumViewerPageComponent = isE2EAuthBypassEnabled ? FrustumViewerPage : secureRoute(FrustumViewerPage);

export const AppRoutes = () => {
    return (
        <Routes>
            <Route Component={HomeComponent} path="" />
            <Route Component={Unauthorized} path="/unauthorized" />
            <Route Component={CataloguePageComponent} path="/catalogue" />
            <Route Component={CataloguePageComponent} path="/catalog" />
            <Route Component={WallFormingRoutesComponent} path={`/${WallFormingBaseRoute}/*`} />
            <Route Component={FrustumViewerPageComponent} path="/frustum-viewer" />
            <Route Component={NotFound} path="*" />
        </Routes>
    );
};
